import { max, sum } from 'd3-array';
import { formatDefaultLocale } from 'd3-format';
import germanFormat from 'd3-format/locale/de-DE';
import debounce from 'lodash.debounce';

germanFormat.percent = '';
germanFormat.currency = ['', ''];

const germanNumberFormat = formatDefaultLocale(germanFormat);

export function nf(num, format = ',', unit = false) {
  if (typeof num === 'undefined') {
    return '';
  }

  const formattedNumber = germanNumberFormat.format(format)(num);

  return unit ? `${formattedNumber} ${unit}` : formattedNumber;
}

export const translate = (x, y) => `translate(${x}, ${y})`;

export function sumDatum(datum, columns) {
  if (!columns || !datum) {
    return 0;
  }

  return sum(columns, (col) => datum[col]);
}

export function maxData(data, columns) {
  return max(data, (d) =>
    sumDatum(
      d,
      columns.map((col) => col.name)
    )
  );
}

function resizeIframe() {
  window.parent.postMessage(
    {
      idwBerufeFrameHeight: document.body.clientHeight + 100,
    },
    '*'
  );
}

export const resizeIframeDebounced = debounce(resizeIframe, 100);

export function isIFrame() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export default {
  translate,
  maxData,
  sumDatum,
  nf,
};
